import { Tabs } from '@mui/material';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  && {
    height: 3rem;
    padding: 0 1.25rem;
    border-bottom: 1px solid
      ${({ theme }) => theme.palette.stroke.secondaryLight};
    background: inherit;
    width: 100%;

    .MuiTabs-flexContainer {
      gap: 0.5rem;
    }

    .MuiTabs-indicator {
      height: 3px;
      border-radius: ${({ theme }) =>
        `${theme.shape.buttonRadius.large} ${theme.shape.buttonRadius.large} 0 0`};
    }

    .MuiTabScrollButton-root {
      &:first-of-type {
        margin-left: -0.5rem;
      }
      &:last-of-type {
        margin-right: -0.5rem;
      }
    }
  }
`;
